import {useEffect} from "react";
import {Authenticator, useAuthenticator, View} from '@aws-amplify/ui-react';
import {useNavigate, useLocation} from 'react-router';
import '@aws-amplify/ui-react/styles.css';
import authenticatorOptions from "../../config/authenticatorOptions";
import styles from './index.module.css'

export default function Index() {
  const {route} = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();
  let from = location.state?.from?.pathname || '/';

  useEffect(() => {
    if (route === 'authenticated') {
      navigate(from, {replace: true});
    }
  }, [route, navigate, from]);

  const mainViewClassNames = ["auth-wrapper", styles.mainView];

  return (
    <View className={mainViewClassNames.join(" ")}>
      <Authenticator
        {...authenticatorOptions}
      />
    </View>
  );
}